module.exports = __webpack_public_path__ + "static/media/share-link-download-mobile.30b118ad.svg";